import React from 'react'
import { useField } from 'formik'
import { TextField, Typography, Grid, MenuItem, Box, Select, IconButton } from '@mui/material'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import EastIcon from '@mui/icons-material/East'
import { TimePicker } from '@mui/x-date-pickers'
import AddIcon from '@mui/icons-material/Add'

const FormField = ({
  name,
  label,
  fieldType,
  options,
  heading,
  sx,
  addOption,
  handleAddOption,
  headerProps,
  ...rest
}) => {
  const { sx: headerSx = {}, ...headerRestProps } = headerProps || {}
  // Use Formik's useField to get field props
  const [field, meta] = useField(name)

  // Determine the field to render based on fieldType
  const renderField = () => {
    switch (fieldType) {
      case 'dropdown':
        return (
          <Box display="flex" alignItems="center" gap="12px">
            <TextField
              sx={sx}
              {...field}
              select
              fullWidth
              label={label}
              error={meta.touched && !!meta.error}
              helperText={meta.touched && meta.error}
              {...rest}
            >
              {options.map((option) => (
                <MenuItem sx={{ color: 'black' }} key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
            {addOption && handleAddOption && (
              <IconButton
                onClick={handleAddOption}
                sx={{
                  height: '56px',
                  width: '56px',
                  border: '1px solid #8C8C8C',
                  borderRadius: '12px',
                  marginBottom: '8px'
                }}
              >
                <AddIcon
                  sx={{
                    color: '#007BFF'
                  }}
                />
              </IconButton>
            )}
          </Box>
        )
      case 'dropdown2':
        return (
          <Select
            multiple
            sx={sx}
            {...field}
            select
            fullWidth
            label={label}
            error={meta.touched && !!meta.error}
            helperText={meta.touched && meta.error}
            {...rest}
          >
            {options.map((option) => (
              <MenuItem sx={{ color: 'black' }} key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </Select>
        )
      case 'dropdown3':
        return (
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <TextField sx={sx} {...field} label={label} />
            <TextField
              sx={sx}
              {...field}
              select
              error={meta.touched && !!meta.error}
              helperText={meta.touched && meta.error}
              {...rest}
            >
              {options.map((option) => (
                <MenuItem sx={{ color: 'black' }} key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </TextField>
          </Box>
        )
      case 'date':
        return (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker sx={sx} {...rest} />
          </LocalizationProvider>
        )
      case 'timeInterval':
        return (
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <TimePicker label="" />
            <EastIcon sx={{ padding: '5px' }} />
            <TimePicker label="" />
          </Box>
        )
      default:
        return (
          <TextField
            sx={sx}
            {...field}
            fullWidth
            label={label}
            error={meta.touched && !!meta.error}
            helperText={meta.touched && meta.error}
            {...rest}
          />
        )
    }
  }

  return (
    <>
      <Typography
        variant="h6"
        sx={{ fontWeight: 'high', padding: '5px', color: 'grey', ...headerSx }}
        {...headerRestProps}
      >
        {heading}
      </Typography>
      {renderField()}
    </>
  )
}

export default FormField
